import styled from 'styled-components';

import Text from 'components/Text';

import { AlertTextComponent } from './types';

const StyledAlertText: AlertTextComponent = styled(Text)``;

export { StyledAlertText };
